'use client';

var ADR_TURBO_ONE = 'banners/v1.0/adr-turbo1';
var ADR_TURBO_TWO = 'banners/v1.0/adr-turbo2';

export { ADR_TURBO_ONE, ADR_TURBO_TWO };
//# sourceMappingURL=const.js.map
